var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row flex-wrap"},[_c('b-link',{staticClass:"classic",attrs:{"href":_vm.schema.href,"active":"","target":"_blank","router-tag":"button"}},[_vm._v(" "+_vm._s(_vm.link)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }